/* =========================================================================
 * assets/reward-select.js — 施策② 特典選択ページ（ウィザード型モーダル）
 * -------------------------------------------------------------------------
 * 施策①のエンジン（survey-popup.js）を踏襲:
 * - 1問1画面: Next で前進（必須は回答チェック後のみ）/ Back で戻る
 * - 進捗: プログレスバー + "Question X of N"（分岐で分母は動的に更新）
 * - 条件分岐 (showIf: equals または in), 複数選択の上限 (maxSelect),
 *   「その他」記述欄 (options[].hasText), select型, 自由記述 (type:"text")
 * ②固有:
 * - ステップ構成 = 設問（config）→ インタビュー可否（必須・liquid側）→ メール（最終・送信）
 * - モーダルは回答完了でのみ閉じる（×・Esc・オーバーレイなし）
 * - 送信は GAS へベストエフォート POST。回答済み再訪はモーダルを出さず選択状態を復元
 * ========================================================================= */
(function () {
  "use strict";

  var root = document.getElementById('ShiroRewardSelect');
  if (!root) return;

  var cfg = window.SHIRO_POST_SURVEY || { questions: [] };
  var gasUrl = root.dataset.gasUrl || '';
  var modal = root.querySelector('[data-survey-modal]');
  var modalBody = root.querySelector('[data-modal-body]');
  var form = root.querySelector('[data-panel="survey"]');
  var rewardsPanel = root.querySelector('[data-panel="rewards"]');
  var container = root.querySelector('[data-survey-questions]');
  var interviewEl = root.querySelector('[data-qid="interview"]');
  var emailEl = root.querySelector('[data-step="email"]');
  var emailInput = root.querySelector('#ShiroRewardEmail');
  var nextBtn = root.querySelector('[data-action="next"]');
  var backBtn = root.querySelector('[data-action="back"]');
  var progressFill = root.querySelector('.shiro-progress__fill');
  var progressLabel = root.querySelector('[data-progress-label-text]');
  if (!modal || !form || !container || !interviewEl || !emailEl) return;

  var NEXT_LABEL = nextBtn.dataset.nextLabel || 'Next';
  var SUBMIT_LABEL = nextBtn.dataset.submitLabel || 'Submit';
  var SENDING_LABEL = modal.dataset.sendingLabel || 'Sending…';
  var Q_ERROR = modal.dataset.qError || 'Please answer this question.';
  var PROGRESS_TPL = modal.dataset.progressLabel || 'Question {x} of {n}';

  var SUBMIT_KEY = 'shiro_reward_submitted';
  var CHOICE_KEY = 'shiro_reward_choice';
  var EMAIL_KEY = 'shiro_reward_email';
  var CODE_KEY = 'shiro_reward_code';
  var ISSUING_LABEL = root.dataset.issuingLabel || 'Preparing your code…';
  var currentStep = 0;

  function lsGet(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function lsSet(key, value) { try { localStorage.setItem(key, value); } catch (e) {} }

  var params = new URLSearchParams(location.search);
  var orderRef = params.get('order') || '';
  if (params.get('email')) emailInput.value = params.get('email');

  function postToGas(payload) {
    if (!gasUrl) { try { console.warn('[shiro-reward] preview mode. payload:', payload); } catch (e) {} return; }
    try {
      fetch(gasUrl, {
        method: 'POST',
        mode: 'no-cors', // レスポンスは読めない前提のベストエフォート
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      }).catch(function () {});
    } catch (e) {}
  }

  // 特典コード発行はレスポンス（発行されたユニークコード）を読む必要があるため
  // no-cors ではなく通常の fetch を使う（GAS Web App は text/plain の単純リクエストなら
  // リダイレクト先で CORS 許可される）。10秒で諦めて null を返す＝共通コードにフォールバック。
  function requestRewardCode(payload) {
    if (!gasUrl) return Promise.resolve(null);
    return new Promise(function (resolve) {
      var done = false;
      var timer = setTimeout(function () { done = true; resolve(null); }, 10000);
      try {
        fetch(gasUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload)
        }).then(function (r) { return r.json(); }).then(function (d) {
          if (done) return;
          clearTimeout(timer);
          resolve(d && d.ok && d.code ? String(d.code) : null);
        }).catch(function () {
          if (done) return;
          clearTimeout(timer);
          resolve(null);
        });
      } catch (e) {
        clearTimeout(timer);
        resolve(null);
      }
    });
  }

  /* ---- 設問レンダリング（①と同じ shiro-q マークアップ。全問生成し1問だけ表示） ---- */
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  cfg.questions.forEach(function (q) {
    var fs = document.createElement('fieldset');
    fs.className = 'shiro-q';
    fs.setAttribute('data-qid', q.id);
    fs.setAttribute('data-type', q.type);
    fs.hidden = true;

    var legend = document.createElement('legend');
    legend.className = 'shiro-q__legend';
    var num = document.createElement('span'); num.className = 'shiro-q__num'; legend.appendChild(num);
    var title = document.createElement('span'); title.className = 'shiro-q__title';
    title.innerHTML = esc(q.label) + (q.labelEn ? '<span class="shiro-q__en">' + esc(q.labelEn) + '</span>' : '');
    legend.appendChild(title);
    var meta = document.createElement('span'); meta.className = 'shiro-q__meta';
    meta.innerHTML = (q.required ? '<span class="shiro-q__req">Required</span>' : '<span class="shiro-q__opt">Optional</span>') +
      (q.note ? '<span class="shiro-q__note">' + esc(q.note) + '</span>' : '');
    legend.appendChild(meta);
    fs.appendChild(legend);

    var list = document.createElement('div');
    list.className = 'shiro-q__options';

    if (q.type === 'text') {
      var textarea = document.createElement('textarea');
      textarea.className = 'shiro-q__textarea';
      textarea.name = 'survey_' + q.id;
      textarea.rows = 4;
      if (q.maxLength) textarea.maxLength = q.maxLength;
      list.appendChild(textarea);
    } else if (q.type === 'select') {
      var sel = document.createElement('select'); sel.className = 'shiro-select'; sel.name = q.id;
      var ph = document.createElement('option'); ph.value = ''; ph.textContent = 'Please select…'; ph.disabled = true; ph.selected = true; sel.appendChild(ph);
      var hasOther = false;
      q.options.forEach(function (opt) {
        var o = document.createElement('option'); o.value = opt.value; o.textContent = opt.label; o.setAttribute('data-label', opt.label);
        if (opt.hasText) hasOther = true;
        sel.appendChild(o);
      });
      list.appendChild(sel);
      var selOther = null;
      if (hasOther) {
        selOther = document.createElement('input'); selOther.type = 'text'; selOther.className = 'shiro-opt__other';
        selOther.placeholder = 'Please specify'; selOther.maxLength = 300; selOther.hidden = true;
        list.appendChild(selOther);
      }
      sel.addEventListener('change', function () {
        if (!selOther) return;
        var chosen = q.options.filter(function (o) { return o.value === sel.value; })[0];
        selOther.hidden = !(chosen && chosen.hasText);
        if (!selOther.hidden) selOther.focus();
      });
    } else {
      q.options.forEach(function (opt, j) {
        var lbl = document.createElement('label'); lbl.className = 'shiro-opt';
        var input = document.createElement('input');
        input.type = q.type === 'single' ? 'radio' : 'checkbox';
        input.name = q.id; input.id = q.id + '_' + j; input.value = opt.value;
        input.setAttribute('data-label', opt.label);
        lbl.appendChild(input);
        var span = document.createElement('span'); span.className = 'shiro-opt__text'; span.textContent = opt.label;
        lbl.appendChild(span);
        list.appendChild(lbl);
        if (opt.hasText) {
          var other = document.createElement('input'); other.type = 'text'; other.className = 'shiro-opt__other';
          other.placeholder = 'Please specify'; other.setAttribute('data-other-for', q.id); other.maxLength = 300; other.hidden = true;
          list.appendChild(other);
          input.addEventListener('change', function () { other.hidden = !input.checked; if (input.checked) other.focus(); });
        }
        if (q.type === 'multi' && q.maxSelect) {
          input.addEventListener('change', function () { enforceMax(fs, q.maxSelect); });
        }
        if (q.type === 'single') {
          input.addEventListener('change', function () { syncOtherInputs(list); });
        }
      });
    }
    fs.appendChild(list);

    var err = document.createElement('p'); err.className = 'shiro-q__error'; err.hidden = true; err.textContent = Q_ERROR;
    fs.appendChild(err);
    container.appendChild(fs);
  });

  function syncOtherInputs(list) {
    Array.prototype.forEach.call(list.querySelectorAll('.shiro-opt'), function (lbl) {
      var input = lbl.querySelector('input');
      var other = lbl.nextElementSibling;
      if (other && other.classList && other.classList.contains('shiro-opt__other')) {
        other.hidden = !input.checked;
      }
    });
  }
  function enforceMax(fs, max) {
    var boxes = fs.querySelectorAll('input[type="checkbox"]');
    var checked = fs.querySelectorAll('input[type="checkbox"]:checked').length;
    Array.prototype.forEach.call(boxes, function (b) { b.disabled = !b.checked && checked >= max; });
  }

  /* ---- パス / 進捗（分岐 showIf: equals または in をサポート） ---- */
  function getValues(qid) {
    var fs = container.querySelector('[data-qid="' + qid + '"]');
    if (!fs) return [];
    var sel = fs.querySelector('select');
    if (sel) return sel.value ? [sel.value] : [];
    return Array.prototype.map.call(fs.querySelectorAll('input:checked'), function (i) { return i.value; });
  }
  function evalShowIf(cond) {
    var picked = getValues(cond.questionId);
    if (cond.in) return picked.some(function (v) { return cond.in.indexOf(v) !== -1; });
    return picked.indexOf(cond.equals) !== -1;
  }
  function computePath() {
    var steps = cfg.questions
      .filter(function (q) { return !q.showIf || evalShowIf(q.showIf); })
      .map(function (q) {
        return { kind: 'q', q: q, el: container.querySelector('[data-qid="' + q.id + '"]') };
      });
    steps.push({ kind: 'interview', el: interviewEl });
    steps.push({ kind: 'email', el: emailEl });
    return steps;
  }

  function allStepEls() {
    var els = Array.prototype.slice.call(container.querySelectorAll('.shiro-q'));
    els.push(interviewEl, emailEl);
    return els;
  }

  function showStep(pos) {
    var path = computePath();
    if (pos < 0) pos = 0;
    if (pos > path.length - 1) pos = path.length - 1;
    currentStep = pos;
    allStepEls().forEach(function (el) { el.hidden = true; });
    var cur = path[pos];
    cur.el.hidden = false;
    var num = cur.el.querySelector('.shiro-q__num');
    if (num) num.textContent = 'Q' + (pos + 1);
    updateProgress();
    backBtn.hidden = pos === 0;
    nextBtn.textContent = (pos === path.length - 1) ? SUBMIT_LABEL : NEXT_LABEL;
    if (modalBody) modalBody.scrollTop = 0;
  }

  function updateProgress() {
    var n = computePath().length;
    var x = currentStep + 1;
    if (x > n) x = n;
    if (progressLabel) progressLabel.textContent = PROGRESS_TPL.replace('{x}', String(x)).replace('{n}', String(n));
    if (progressFill) progressFill.style.width = Math.round((x / n) * 100) + '%';
  }
  // 分岐元の回答が変わったら分母を即時更新
  container.addEventListener('change', updateProgress);

  /* ---- バリデーション ---- */
  function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  function validateStep(step) {
    var err = step.el.querySelector('.shiro-q__error');
    if (err) err.hidden = true;

    if (step.kind === 'email') {
      if (!isValidEmail((emailInput.value || '').trim())) {
        if (err) err.hidden = false;
        emailInput.focus();
        return false;
      }
      return true;
    }
    if (step.kind === 'interview') {
      if (step.el.querySelectorAll('input:checked').length === 0) {
        if (err) err.hidden = false;
        return false;
      }
      return true;
    }
    // config設問
    var q = step.q;
    if (!q.required) return true;
    if (q.type === 'text') {
      var value = step.el.querySelector('textarea').value.trim();
      if (!value) { if (err) err.hidden = false; return false; }
      return true;
    }
    var sel = step.el.querySelector('select');
    if (sel) {
      if (!sel.value) { if (err) err.hidden = false; return false; }
      return true;
    }
    if (step.el.querySelectorAll('input:checked').length === 0) {
      if (err) err.hidden = false;
      return false;
    }
    return true;
  }

  /* ---- Next / Back ---- */
  nextBtn.addEventListener('click', function () {
    var path = computePath();
    var step = path[currentStep];
    if (!validateStep(step)) return;
    path = computePath(); // 分岐の変化を反映
    if (currentStep >= path.length - 1) { doSubmit(path); return; }
    showStep(currentStep + 1);
  });
  backBtn.addEventListener('click', function () { if (currentStep > 0) showStep(currentStep - 1); });
  form.addEventListener('submit', function (e) { e.preventDefault(); nextBtn.click(); }); // Enterキー対応

  /* ---- 回答収集（①と同じくラベル文字列で集計、"その他" は qid_other） ---- */
  function collectAnswers(path) {
    var flat = {};
    path.forEach(function (step) {
      if (step.kind !== 'q') return;
      var q = step.q;
      var fs = step.el;
      if (q.type === 'text') {
        var value = fs.querySelector('textarea').value.trim();
        if (value) flat[q.id] = value;
        return;
      }
      var sel = fs.querySelector('select');
      if (sel) {
        if (sel.value) {
          var o = sel.options[sel.selectedIndex];
          flat[q.id] = o.getAttribute('data-label') || o.textContent;
          var so = fs.querySelector('.shiro-opt__other');
          if (so && !so.hidden && so.value.trim()) flat[q.id + '_other'] = so.value.trim();
        }
        return;
      }
      var checked = fs.querySelectorAll('input:checked');
      if (checked.length) {
        flat[q.id] = Array.prototype.map.call(checked, function (i) { return i.getAttribute('data-label'); }).join(' | ');
      }
      var ot = fs.querySelector('.shiro-opt__other:not([hidden])');
      if (ot && ot.value.trim()) flat[q.id + '_other'] = ot.value.trim();
    });
    return flat;
  }

  /* ---- モーダル開閉（閉じる手段は回答完了のみ） ---- */
  function openModal() {
    modal.hidden = false;
    document.documentElement.classList.add('shiro-reward-modal-open');
  }
  function closeModal() {
    modal.hidden = true;
    document.documentElement.classList.remove('shiro-reward-modal-open');
  }

  /* ---- 送信 ---- */
  function doSubmit(path) {
    var email = (emailInput.value || '').trim();
    var interview = interviewEl.querySelector('input:checked').value;
    nextBtn.disabled = true;
    nextBtn.textContent = SENDING_LABEL;

    lsSet(EMAIL_KEY, email);
    lsSet(SUBMIT_KEY, '1');
    postToGas({
      type: 'post_purchase',
      email: email,
      interview: interview,
      answers: collectAnswers(path),
      order: orderRef,
      surveyVersion: cfg.version || '',
      page: location.pathname,
      userAgent: navigator.userAgent,
      clientSubmittedAt: new Date().toISOString()
    });
    closeModal();
  }

  /* ---- 特典選択（1つ選んだら確定し、他は無効化） ---- */
  function lockChoice(chosen) {
    rewardsPanel.querySelectorAll('[data-reward]').forEach(function (btn) {
      if (btn.dataset.reward !== chosen) btn.disabled = true;
    });
  }
  function revealReward(reward, code) {
    if (reward === 'sample') {
      rewardsPanel.querySelector('[data-reward-sample-display]').hidden = false;
    } else if (code) {
      var box = rewardsPanel.querySelector('[data-reward-code-display]');
      box.querySelector('[data-reward-code-value]').textContent = code;
      // Shop now: /discount/コード で自動適用し、特典に応じた遷移先へ
      var shopNow = box.querySelector('[data-reward-shop-now]');
      if (shopNow) {
        var redirect = reward === 'shaker'
          ? (root.dataset.shopnowShaker || '/')
          : (root.dataset.shopnow5off || '/');
        shopNow.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
        shopNow.hidden = false;
      }
      box.hidden = false;
      box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    lockChoice(reward);
  }
  rewardsPanel.querySelectorAll('[data-reward]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!lsGet(SUBMIT_KEY)) return; // アンケート未回答（モーダル表示中）は選択不可
      if (lsGet(CHOICE_KEY)) return;  // 選択済みなら何もしない
      var reward = btn.dataset.reward;
      lsSet(CHOICE_KEY, reward);
      lockChoice(reward);
      var payload = {
        type: 'post_purchase_reward',
        email: lsGet(EMAIL_KEY) || (emailInput.value || '').trim(),
        reward: reward,
        order: orderRef
      };

      if (reward === 'sample') {
        postToGas(payload);
        revealReward(reward, '');
        return;
      }

      // ユニークコードを発行して表示。失敗時は共通コード（data-code）にフォールバック
      var originalLabel = btn.textContent;
      btn.disabled = true;
      btn.textContent = ISSUING_LABEL;
      requestRewardCode(payload).then(function (code) {
        if (!code) postToGas(payload); // 応答が読めなかった場合の記録バックアップ（GAS側で二重発行は防止）
        var finalCode = code || btn.dataset.code || '';
        lsSet(CODE_KEY, finalCode);
        btn.textContent = originalLabel;
        btn.disabled = false;
        revealReward(reward, finalCode);
      });
    });
  });

  /* ---- 初期表示 ---- */
  if (lsGet(SUBMIT_KEY)) {
    var chosen = lsGet(CHOICE_KEY);
    if (chosen) {
      var btn = rewardsPanel.querySelector('[data-reward="' + chosen + '"]');
      revealReward(chosen, lsGet(CODE_KEY) || (btn ? btn.dataset.code : ''));
    }
  } else {
    showStep(0);
    openModal();
  }
})();